const ActionLoader = () => {
  return (
    <div className="w-screen h-screen flex justify-center items-center fixed z-[1002] bg-[rgba(255,255,255,0.8)]">
      <div className="action-loader w-5 h-5 flex justify-center items-center relative bg-black rounded-[50%]"></div>
    </div>
  );
};

export default ActionLoader;
